import floating from "../../image/originals/quantum/floating.webp";
import floating2 from "../../image/originals/quantum/floating2.webp";


import ItemNoSize from "./ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: 3,
      name: "Twin Flame",
      image: floating,
      price: "$6000.00",
      thumbnails: [floating, floating2],
      description: "20 x 20” Museum Rag Paper",
      projectUrl: "",
      sizes: ["36 X 47"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
